var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDash = function SvgDash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.646 12.493v.016a3.073 3.5 0 0 0-3.052 3.498 3.073 3.5 0 0 0 3.073 3.5 3.073 3.5 0 0 0 .17-.014h16.326a3.073 3.5 0 0 0 .17.014 3.073 3.5 0 0 0 3.073-3.5 3.073 3.5 0 0 0-3.073-3.5 3.073 3.5 0 0 0-.005 0v-.014z"
  })));
};
export default SvgDash;